import LegalPage from '../components/ui/LegalPage.jsx'

export default function Mail() {
  return (
    <LegalPage
      title="Send Us a Message"
      description="Send a message to FastAudio support for DMCA takedown notices, partnership enquiries, or general feedback."
      slug="mail"
    >
      <p>
        For support requests, DMCA takedown notices, partnership enquiries, or general feedback,
        please use the form below or email us directly.
      </p>

      <p>
        <strong className="text-foreground">Email:</strong>{' '}
        <a href="mailto:support@fastaudio.cc" className="text-primary hover:underline">
          support@fastaudio.cc
        </a>
      </p>

      <form
        className="mt-6 space-y-5 not-prose"
        onSubmit={e => { e.preventDefault(); alert('Message sent! We\'ll be in touch shortly.') }}
      >
        <div>
          <label htmlFor="mail-email" className="block text-sm font-medium text-foreground mb-1.5">
            Your Email
          </label>
          <input
            id="mail-email"
            type="email"
            required
            placeholder="you@example.com"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm"
          />
        </div>

        <div>
          <label htmlFor="mail-message" className="block text-sm font-medium text-foreground mb-1.5">
            Message
          </label>
          <textarea
            id="mail-message"
            required
            rows={5}
            placeholder="Describe your request…"
            className="w-full px-4 py-2.5 rounded-xl border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 text-sm resize-none"
          />
        </div>

        <button
          type="submit"
          className="px-6 py-2.5 rounded-xl bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors"
        >
          Send Message
        </button>
      </form>
    </LegalPage>
  )
}
